// extracted by mini-css-extract-plugin
export default {"Wrapper":"StrategyRadioButton_Wrapper__f8VCo","Radio":"StrategyRadioButton_Radio__xRbh4"};